const pageNameKey = "patchTicketAssigneesDropdown";

export const patchTicketAssigneesDropdownEn = {
  [pageNameKey]: {
    selectAssigneeLabel: "Select assignee",
    noAssigneesAvailable: "No assignees available",
    errorUpdatingAssignee: "It was not possible to update the ticket assignee.",
    errorFetchingAssignees:
      "It was not possible to fetch the possible assignees.",
    successUpdatingAssignee: "Ticket assignee updated successfully.",
  },
};

export const patchTicketAssigneesDropdownPtBr = {
  [pageNameKey]: {
    selectAssigneeLabel: "Selecione o responsável",
    noAssigneesAvailable: "Nenhum responsável disponível",
    errorUpdatingAssignee:
      "Não foi possível atualizar o responsável pelo ticket.",
    errorFetchingAssignees:
      "Não foi possível buscar os possíveis responsáveis.",
    successUpdatingAssignee: "Responsável pelo ticket atualizado com sucesso.",
  },
};

export const patchTicketAssigneesDropdownDe = {
  [pageNameKey]: {
    selectAssigneeLabel: "Beauftragte auswählen",
    noAssigneesAvailable: "Keine verfügbaren Beauftragten",
    errorUpdatingAssignee:
      "Die Aktualisierung des Ticket-Beauftragten ist fehlgeschlagen.",
    errorFetchingAssignees:
      "Die verfügbaren Beauftragten konnten nicht abgerufen werden.",
    successUpdatingAssignee: "Ticket-Beauftragter erfolgreich aktualisiert.",
  },
};

export const patchTicketAssigneesDropdownZhHans = {
  [pageNameKey]: {
    selectAssigneeLabel: "选择受让人",
    noAssigneesAvailable: "没有可用的受让人",
    errorUpdatingAssignee: "无法更新工单受让人。",
    errorFetchingAssignees: "无法获取可用的受让人。",
    successUpdatingAssignee: "工单受让人更新成功。",
  },
};

export const patchTicketAssigneesDropdownIt = {
  [pageNameKey]: {
    selectAssigneeLabel: "Seleziona assegnatario",
    noAssigneesAvailable: "Nessun assegnatario disponibile",
    errorUpdatingAssignee:
      "Non è stato possibile aggiornare l'assegnatario del ticket.",
    errorFetchingAssignees:
      "Non è stato possibile recuperare i possibili assegnatari.",
    successUpdatingAssignee: "Assegnatario del ticket aggiornato con successo.",
  },
};

export const patchTicketAssigneesDropdownEs = {
  [pageNameKey]: {
    selectAssigneeLabel: "Seleccionar responsable",
    noAssigneesAvailable: "No hay responsables disponibles",
    errorUpdatingAssignee:
      "No fue posible actualizar el responsable del ticket.",
    errorFetchingAssignees: "No fue posible obtener los posibles responsables.",
    successUpdatingAssignee:
      "El responsable del ticket se actualizó correctamente.",
  },
};

export const patchTicketAssigneesDropdownNl = {
  [pageNameKey]: {
    errorFetchingAssignees:
      "Het was niet mogelijk om de mogelijke toegewezen personen op te halen.",
    errorUpdatingAssignee:
      "Het was niet mogelijk om de toegewezen persoon van het ticket bij te werken.",
    noAssigneesAvailable: "Geen toegewezen personen beschikbaar",
    selectAssigneeLabel: "Toegewezen persoon selecteren",
    successUpdatingAssignee:
      "Toegewezen persoon van het ticket succesvol bijgewerkt.",
  },
};

export const patchTicketAssigneesDropdownTr = {
  [pageNameKey]: {
    errorFetchingAssignees: "Muhtemel atananları getirmek mümkün olmadı.",
    errorUpdatingAssignee: "Bileti atanan kişi güncellenemedi.",
    noAssigneesAvailable: "Atanan kişi yok",
    selectAssigneeLabel: "Atanan kişiyi seçin",
    successUpdatingAssignee: "Bileti devralan kişi başarıyla güncellendi.",
  },
};
